import SEO from "@/components/base/SEO";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import FeaturedSection from "./components/FeaturedSection";
import CategorySection from "./components/CategorySection";
import PopularSection from "./components/PopularSection";
import LatestSection from "./components/LatestSection";
import FAQSection from "./components/FAQSection";
import CTASection from "./components/CTASection";

const siteUrl = "https://hanmanzhijia.com";

export default function Home() {
  const homeJsonLd = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "韩漫之家",
    url: siteUrl,
    description: "好看韩国漫画，韩漫在线免费阅读，高清韩漫大全。在韩漫之家享受可靠服务，欣赏好看韩国漫画的韩漫在线免费阅读与高清韩漫大全。",
    potentialAction: {
      "@type": "SearchAction",
      target: {
        "@type": "EntryPoint",
        urlTemplate: `${siteUrl}/search?q={search_term_string}`,
      },
      "query-input": "required name=search_term_string",
    },
  };

  const orgJsonLd = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "韩漫之家",
    url: siteUrl,
    description: "好看韩国漫画，韩漫在线免费阅读，高清韩漫大全。提供稳定优质韩国漫画阅读体验。",
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "400-888-8888",
      contactType: "customer service",
      availableLanguage: "Chinese",
    },
  };

  return (
    <>
      <SEO
        title="好看韩国漫画_韩漫在线免费阅读-高清韩漫大全-韩漫之家"
        description="好看韩国漫画，韩漫在线免费阅读，高清韩漫大全，韩漫之家，可靠服务。在韩漫之家享受可靠服务，欣赏好看韩国漫画的韩漫在线免费阅读与高清韩漫大全，带给您稳定优质的阅读体验。"
        keywords="好看韩国漫画,韩漫在线免费阅读,高清韩漫大全,韩漫之家,可靠服务"
        canonicalUrl={siteUrl}
        ogImage="https://readdy.ai/api/search-image?query=Korean%20manhwa%20website%20preview%20banner%2C%20artistic%20illustration%20style%2C%20warm%20cream%20and%20coral%20tones%2C%20elegant%20typography%20friendly%20design%2C%20cozy%20reading%20vibe%2C%20minimalist%20composition&width=1200&height=630&seq=og-home&orientation=landscape"
        ogImageWidth="1200"
        ogImageHeight="630"
        jsonLd={{ ...homeJsonLd, ...orgJsonLd }}
      />

      <Navbar />

      <main>
        <HeroSection />
        <FeaturedSection />
        <CategorySection />
        <PopularSection />
        <LatestSection />
        <FAQSection />
        <CTASection />
      </main>

      <Footer />
    </>
  );
}